import {AbstractStorage} from "../../services/storage/abstract-storage";
import {LocalStorageService} from "../../services/storage/local-storage";

const CourseOverviewDisplayedKeyPrefix = `coursesOverviewDisplayed`;

export class CourseViewedOnDeviceRepository {
  constructor(private storage: AbstractStorage = new LocalStorageService()) {
  }

  private createStorageKeyForCourseId(courseId: number): string {
    return `${CourseOverviewDisplayedKeyPrefix}:${courseId}`;
  }

  public setDisplayedCourse(courseId: number) {
    this.storage.setJsonItem<boolean>(this.createStorageKeyForCourseId(courseId), true);
  }

  public hasOverviewBeenDisplayed(courseId: number): boolean {
    return this.storage.getJsonItem<boolean>(this.createStorageKeyForCourseId(courseId)) ?? false;
  }
}

export const courseViewedOnDeviceRepository = new CourseViewedOnDeviceRepository();
